/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:eb96fec3-2254-4b36-86d1-f13e17289219",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_PQHvb9EIP",
    "aws_user_pools_web_client_id": "hg7idvaimv9ao2k0bjdl7n0d2",
    "oauth": {
        "domain": "students-edlyft-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://localhost:3000/",
        "redirectSignOut": "https://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS"
};


export default awsmobile;
